import { IMenuItem } from "./MenuItem";
import { AUTH_PAGES } from "~/constants/navigation";
import { createNavigationItem, getNavigationTextAsString } from "~/utils/navigation";
import dynamic from "next/dynamic";

const ShopMegaMenuContent = dynamic(() => import("./ShopMegaMenuContent"), { ssr: false });
const LearnMegaMenuContent = dynamic(() => import("./LearnMegaMenuContent"), { ssr: false, });

export const authMenuItems: IMenuItem[] = AUTH_PAGES.map(item => ({
    text: getNavigationTextAsString(item.text),
    href: item.href,
    gtmEventData: item.gtmEventData,
    handleClick: item.handleClick,
    target: item.target,
}));

export const unAuthMenuItems: IMenuItem[] = [
    {
        text: "Shop",
        href: "#",
        megaMenuChildren: <ShopMegaMenuContent />,
    },
    {
        text: "Learn",
        href: "#",
        megaMenuChildren: <LearnMegaMenuContent />,
    },
    {
        ...createNavigationItem("Reviews", "/reviews"),
        text: "Reviews",
    },
    {
        ...createNavigationItem("FAQ", "/p/faq"),
        text: "FAQ",
    },
];
